"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../SQONView/utils");

var _Location = _interopRequireDefault(require("../Location"));

var _TermAgg = _interopRequireDefault(require("./TermAgg"));

var _AggsQuery = _interopRequireDefault(require("./AggsQuery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(_ref) {
  var index = _ref.index,
      _ref$aggs = _ref.aggs,
      aggs = _ref$aggs === void 0 ? [] : _ref$aggs,
      props = _objectWithoutProperties(_ref, ["index", "aggs"]);

  return !aggs.length ? null : /*#__PURE__*/_react["default"].createElement(_AggsQuery["default"], _extends({
    index: index,
    aggs: aggs,
    render: function render(_ref2) {
      var data = _ref2.data,
          loading = _ref2.loading;
      return loading ? 'loading' : /*#__PURE__*/_react["default"].createElement("div", {
        className: "remainder"
      }, Object.entries(data[index].aggregations).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            field = _ref4[0],
            data = _ref4[1];

        return /*#__PURE__*/_react["default"].createElement(_Location["default"], {
          key: field,
          render: function render(search) {
            return /*#__PURE__*/_react["default"].createElement(_TermAgg["default"], {
              field: field,
              buckets: data.buckets,
              isActive: function isActive(d) {
                return (0, _utils.inCurrentFilters)({
                  key: d.value,
                  dotField: d.field,
                  currentFilters: (search.filters || {}).content
                });
              },
              handleFieldClick: function handleFieldClick(d) {// history.push({
                //   search: stringify({
                //     filters: JSON.stringify({
                //       op: 'and',
                //       content: [
                //         {
                //           op: 'in',
                //           content: {
                //             field: d.field,
                //             value: [d.value],
                //           },
                //         },
                //       ],
                //     }),
                //   }),
                // });
              }
            });
          }
        });
      }));
    }
  }, props));
};

exports["default"] = _default;